// Every currency a quotation / proforma / invoice can be raised in. INR first,
// then the ones RBM's export clients usually pay in, then every other ISO-4217
// currency the browser knows (alphabetical) — searchable, so the long tail is
// one keystroke away instead of a 170-row scroll.

const COMMON = [
  'INR', 'USD', 'EUR', 'GBP', 'AED', 'SAR', 'QAR', 'OMR', 'KWD', 'BHD',
  'SGD', 'AUD', 'CAD', 'JPY', 'CNY', 'ZAR', 'KES', 'NGN', 'BDT', 'LKR', 'NPR',
];

function currencyName(code: string): string {
  try {
    return new Intl.DisplayNames(['en'], { type: 'currency' }).of(code) || code;
  } catch {
    return code;
  }
}

function allCodes(): string[] {
  try {
    const fn = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
    if (typeof fn === 'function') return fn('currency');
  } catch { /* older browser — the common list still works */ }
  return [];
}

export interface CurrencyOption { value: string; label: string }

export const CURRENCY_OPTIONS: CurrencyOption[] = (() => {
  const rest = allCodes().filter((c) => !COMMON.includes(c)).sort();
  return [...COMMON, ...rest].map((code) => ({
    value: code,
    label: code === 'INR' ? 'INR — Indian Rupee (no conversion)' : `${code} — ${currencyName(code)}`,
  }));
})();
